import {useState, useRef} from "react"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useTeamContext} from "../../reactContext/contextCustomHooks/useTeamContext"
import {useTranslation} from "react-i18next"
import axios from "axios"
import {API_LEXICONS} from "../../constants/apiUrls"
import useLexicons from "../../swrCustomHooks/useLexicons"
import LexiconCard from "../../components/lexicon-card/LexiconCard"
import AddLexiconBtn from "../../components/add-lexicon-btn/AddLexiconBtn"
import {TagsInput} from "react-tag-input-component"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import useTeamLexiconId from "../../swrCustomHooks/useTeamLexiconId"
import useClickOutside from "../../tools/useClickOutside"
import isLicenceValidity from "../../tools/isLicenceValidity"

export default function LexiconsContent() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {teamContext} = useTeamContext()
    const {teamLexiconId, isLoadingTeamLexiconId, isErrorTeamLexiconId} = useTeamLexiconId(sessionContext.idTeam)
    const {lexicons, isLoadingLexicons, isErrorLexicons} = useLexicons()
    const [lexiconSelected, setLexiconSelected] = useState()
    const [selected, setSelected] = useState()
    const lexiconRef = useRef(null)

    useClickOutside(lexiconRef, () => {
        setLexiconSelected()
    })

    const handleRequest = (data) => {
        setSelected(data)
        const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
        axios.put(`${API_LEXICONS}/${lexiconSelected.id}/items`, data, headersRequest)
        .then((response) => {
            console.log("PUT /lexicons/lexicon/items: ", response)
        })
        .catch((error) => {
            console.error("PUT /lexicons/lexicon/items: ", error)
        })
    }

    if (isErrorTeamLexiconId || isErrorLexicons || isLoadingTeamLexiconId || isLoadingLexicons || teamLexiconId.message || lexicons.message) return <LoadingComponent/>
    return (
        <>
        <div className="SECTION LEXICONS-CONTENT">
            <ul className="lexicon-list">
                <AddLexiconBtn/>
                {teamLexiconId && <LexiconCard index={0} lexicon={{id: teamLexiconId, name: t("Team Lexicon")}} setLexiconSelected={setLexiconSelected} setSelected={setSelected} teamLexicon={true}/>}
                {lexicons.map((lexicon, index) => (
                    <LexiconCard key={`team-${index}`} index={index + 1} lexicon={lexicon} setLexiconSelected={setLexiconSelected} setSelected={setSelected}/>
                ))}
            </ul>
            {lexiconSelected === undefined ? "" :
            <>
            <div ref={lexiconRef} className="lexicon-edit">
                <h2>{lexiconSelected.name}</h2>
                <ul className="word-list">
                    {!isLicenceValidity(teamContext.licenceStartDate, teamContext.licenceEndDate) ?
                        <TagsInput value={selected} onChange={handleRequest} name="word" disabled={true}/>
                    : (sessionContext.role === "admin" || sessionContext.role === "team_admin") && (lexiconSelected.id === teamLexiconId) ?
                        <TagsInput value={selected} onChange={handleRequest} name="word" placeHolder={t("Add a word")}/>
                    : sessionContext.role === "user" && (lexiconSelected.id === teamLexiconId) ?
                        <TagsInput value={selected} onChange={handleRequest} name="word" disabled={true}/>
                    :
                        <TagsInput value={selected} onChange={handleRequest} name="word" placeHolder={t("Add a word")}/>
                    }
                </ul>
            </div>
            </>}
        </div>
        </>
    )
}